import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgModule } from "@angular/core";
import { NotificationListComponent } from "./notification-list/notification-list.component";
import { NotificationsService } from "./notifications.service";

const routes: Routes = [
  { path: "list", component: NotificationListComponent },
  { path: "", redirectTo: "list", pathMatch: "full" },
];

@NgModule({
  declarations: [NotificationListComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule.forChild(routes),
  ],
  exports: [NotificationListComponent],
  providers: [NotificationsService],
})
export class NotificationsModule {}

